import { BaseModeAdapter } from "./baseMode.adapter";
import { MODE_TYPE } from "../reducers/mode.reducer";

export const SERVER_MODE_TYPE = {
  POLY_LINE: "polyline"
};

export class PencilModeAdapter extends BaseModeAdapter {
  // todo move down
  constructor() {
    super();
  }

  getMode(item) {
    const { elementColor, elementId, type, stroke, pageId } = item;
    return {
      id: elementId,
      type: this.getModeType(type),
      data: {
        color: elementColor,
        isActive: false,
        points: this.getPoints(stroke)
      },
      selectedPageId: pageId
    };
  }

  getServer(_data, _id, _type, _flowId, _classId, _selectedPageId) {
    return {
      angle: 0, // todo
      bounds: {
        // todo
        x: 100,
        y: 100,
        width: 100,
        height: 100
      },
      broadcast: false, // todo
      classKey: "", // todo
      class_id: _classId,
      clientId: "12345", // todo
      clientName: "", // todo
      elementColor: _data.color,
      elementSize: 10, // todo
      //flowId: "", // todo
      flowId: _flowId,
      elementId: _id,
      isNew: true, // todo
      opacity: 0.5, // todo
      pageId: _selectedPageId,
      scale: { x: 1, y: 1 }, // todo
      sid: "", // todo
      stroke: this.getStroke(_data.points),
      timestamp: Date.now(),
      type: "polyline"
    };
  }
  getStroke(points) {
    if (typeof points === "undefined") return "";

    let stroke = "";
    points.forEach(point => {
      stroke += point + " ";
    });
    stroke = stroke.substr(0, stroke.length - 1);
    return stroke;
  }

  getModeType(serverType) {
    switch (serverType) {
      case SERVER_MODE_TYPE.POLY_LINE:
        return MODE_TYPE.PENCIL_MODE;

      default:
        return "";
    }
  }

  getPoints(stroke) {
    let strokeArray = stroke.split(" ");
    return strokeArray.map(strokeElement => {
      return parseInt(strokeElement);
    });
  }
}
